import IconCheck from './IconCheck';
import IconCircle from './IconCircle';
import IconClose from './IconClose';
import IconException from './IconException';
import IconLightning from './IconLightning';
import IconNotes from './IconNotes';
import IconRestriction from './IconRestriction';
import IconPerson from './IconPerson';
import IconSortDown from './IconSortDown';
import IconSortUp from './IconSortUp';
import IconChevronUp from './IconChevronUp';
import IconChevronDown from './IconChevronDown';
import IconChevronRight from './IconChevronRight';

export const Check = IconCheck;
export const Circle = IconCircle;
export const Close = IconClose;
export const Exception = IconException;
export const Lightning = IconLightning;
export const Notes = IconNotes;
export const Restriction = IconRestriction;
export const Person = IconPerson;
export const SortDown = IconSortDown;
export const SortUp = IconSortUp;
export const ChevronUp = IconChevronUp;
export const ChevronDown = IconChevronDown;
export const ChevronRight = IconChevronRight;
